import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { CompaniesService } from 'app/services/company/companies.service';
import { ApplicationCompany } from '../../../../models/applicationCompany.model';
import { DataTableCustomButton } from '../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { ApplicationService } from '../../../../services/application/applications.service';

@Component({
    selector: 'app-company-applications-form',
    templateUrl: './companyApplicationsForm.component.html',
    styles: ['label.required:after {top: 0}']
})
export class CompanyApplicationsFormComponent implements OnChanges, OnInit {

  @Output() companyApplicationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() companyApplicationUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCompanyApplications: ApplicationCompany;

  applications: {value: number, label: string}[];
  selectedApplicationsClone = [];
  form: FormGroup;
  addEditForm: FormGroup;
  customButtons: DataTableCustomButton[];
  perm: KonPermission = new KonPermission();
  newDataAvailable = false;

  fields: any;
  public invalidSubmit: boolean;

  constructor (
    private fb: FormBuilder,
    private srvTranslate: TranslateService,
    private srvApplication: ApplicationService,
    private srvCompany: CompaniesService) {

      this.srvTranslate.get([
        'companyApplications.applicationName',
        'companyApplications.app_icon',
        'companyApplications.msBaseUrl',
        'common.back']).subscribe((res) => {
          this.customButtons = [
            {label: res['common.back'], callbackname: 'back', icon: 'fa fa-angle-double-left', isAlwaysEnabled: true}
          ];
      });
  }

  ngOnInit(): void {
    this.applications =  sessionStorage.getItem('compAppApplications') ? JSON.parse(sessionStorage.getItem('compAppApplications')) : [{value: null, label: ''}];

    this.addEditForm = this.fb.group({
      'applicationName': new FormControl (this.dialogBoxCompanyApplications.applicationName),
      'applicationId': new FormControl (this.dialogBoxCompanyApplications.applicationId),
      'app_icon': new FormControl (this.dialogBoxCompanyApplications.app_icon),
      'msBaseUrl': new FormControl (this.dialogBoxCompanyApplications.msBaseUrl)
    });

    this.srvCompany.getFieldsApp().subscribe(res => {
      this.fields = res;
    });

    if (!sessionStorage.getItem('compAppApplications')) {
      this.srvApplication.getAll().subscribe(
        data => {
          for (const app of data) {
            this.applications.push({
              value: app.id,
              label: app.name
            });
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('compAppApplications', JSON.stringify(this.applications))
      );
    }

  }

  ngOnChanges(changes) {
    if (changes.selectedApplications) {
      this.selectedApplicationsClone = [];
      changes.selectedApplications.currentValue.forEach(function(c){
        let clone = Object.assign({}, c);
        this.selectedApplicationsClone.push(clone);
      }, this);
    }
  }

  onChangeApplication(e) {
    let obj = this.applications.filter(x => x.value === e.value);
    this.addEditForm.controls['applicationName'].setValue(obj[0].label);
 }

  saveOrUpdate() {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxCompanyApplications, this.addEditForm.value);
    if (newData.id == null) {
      this.companyApplicationAdded.emit(newData);
    } else {
      this.companyApplicationUpdated.emit(newData);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/company/applications/companyApplicationsForm.component.ts